module.exports = __webpack_public_path__ + "static/media/registrationHeader.efdd2bd9.png";